import { keepPreviousData, useQuery } from "@tanstack/react-query"

import { v1GetHomeDiscoverySession } from "@be-miniapp/api"
import type { Location } from "@be-miniapp/types"

import { useUserPersistingData } from "@/store/user-persisting-data"
import { useUserStore } from "@/store/user-session"

export const homeDiscoverySessionsQueryKey = {
  all: ["home-discovery-sessions"] as const,
  location: (location: Location) => [
    ...homeDiscoverySessionsQueryKey.all,
    location,
  ],
}

export function useHomeDiscoverySession() {
  const accessToken = useUserStore((state) => state.access_token)
  const allowLocationStatus = useUserPersistingData(
    (state) => state.locationPermissionState.status
  )

  const enabled = !!accessToken && allowLocationStatus !== "not-asked"

  const location = useUserStore((state) => state.location)

  // Only create valid location for query key if coordinates are available
  const validLocation: Location | null =
    location.latitude !== undefined && location.longitude !== undefined
      ? { latitude: location.latitude, longitude: location.longitude }
      : null

  return useQuery({
    queryKey: validLocation
      ? homeDiscoverySessionsQueryKey.location(validLocation)
      : homeDiscoverySessionsQueryKey.all,
    queryFn: async () => {
      const data = await v1GetHomeDiscoverySession()
      return data
    },
    enabled: enabled,
    refetchInterval: 30000,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  })
}
